export default __webpack_public_path__ + "static/media/s3.888168d5.jpg";